/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TuitionRateType = {
    TieredByClassCount: 'TieredByClassCount',
    FlatPerClass: 'FlatPerClass',
    PerHour: 'PerHour',
    PerSession: 'PerSession',
    TieredByClassHours: 'TieredByClassHours',
    TieredByActualClassHours: 'TieredByActualClassHours'
} as const;
export type TuitionRateType = typeof TuitionRateType[keyof typeof TuitionRateType];


export function instanceOfTuitionRateType(value: any): boolean {
    for (const key in TuitionRateType) {
        if (Object.prototype.hasOwnProperty.call(TuitionRateType, key)) {
            if (TuitionRateType[key as keyof typeof TuitionRateType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TuitionRateTypeFromJSON(json: any): TuitionRateType {
    return TuitionRateTypeFromJSONTyped(json, false);
}

export function TuitionRateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuitionRateType {
    return json as TuitionRateType;
}

export function TuitionRateTypeToJSON(value?: TuitionRateType | null): any {
    return value as any;
}

export function TuitionRateTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): TuitionRateType {
    return value as TuitionRateType;
}

